"use strict";
/* eslint-disable no-param-reassign */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConsentDialogService = void 0;
const Common_1 = require("./Common");
const Logger_1 = __importDefault(require("./Logger"));
class UserConsentDialogService {
    constructor(contextService, userService) {
        this.contextService = contextService;
        this.userService = userService;
        this.checkboxes = [];
        this.buttons = [];
        const container = document.createElement("div");
        container.innerHTML = Common_1.consentDialogHTML;
        document.body.appendChild(container);
        this.dialog = container.firstElementChild;
        this.dialog.addEventListener("cancel", (event) => {
            event.preventDefault();
        });
        const selectAllButton = container.querySelector("[data-adp-ref=selectAllText]");
        this.buttons.push(selectAllButton);
        selectAllButton.addEventListener("click", () => {
            this.checkboxes.forEach((input) => {
                input.checked = true;
            });
        });
        const okButton = container.querySelector("[data-adp-ref=okButtonText]");
        this.buttons.push(okButton);
        okButton.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () {
            const oldState = new Map();
            try {
                const preferences = this.checkboxes.map((checkbox) => ({
                    consentId: checkbox.id,
                    optIn: checkbox.checked,
                }));
                this.disableInteractive(oldState);
                yield this.userService.setCurrentUserConsentPreferences(preferences);
            }
            catch (e) {
                Logger_1.default.error("There is something wrong when save User Consent Preference", e);
            }
            finally {
                this.dialog.close();
                this.restoreInteractive(oldState);
            }
        }));
    }
    disableInteractive(oldState) {
        [...this.checkboxes, ...this.buttons].forEach((element) => {
            oldState.set(element, element.disabled);
            element.disabled = true;
        });
    }
    restoreInteractive(oldState) {
        oldState === null || oldState === void 0 ? void 0 : oldState.forEach((disabled, element) => {
            element.disabled = disabled;
        });
    }
    showUserConsentDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            const consentPreferences = yield this.userService.getCurrentUserConsentPreferences();
            const consentCopy = yield this.userService.getCurrentUserConsentCopy();
            if (this.contextService.context.callback.buildUserConsentDialog) {
                this.contextService.context.callback.buildUserConsentDialog(consentPreferences, consentCopy, this.userService.saveUserConsentDetectToken);
            }
            else {
                this.updateDialog(consentPreferences, consentCopy);
                this.dialog.showModal();
            }
        });
    }
    bindHTML(root, data, ...refs) {
        refs.forEach((ref) => {
            const selector = `[data-adp-ref=${String(ref)}]`;
            const element = root.querySelector(selector);
            element.innerHTML = String(data[ref]);
            element.querySelectorAll("a").forEach((link) => {
                link.setAttribute("target", "_blank");
            });
        });
    }
    updateDialog(consentPreferences, consentCopy) {
        var _a, _b;
        const preferences = Object.fromEntries(consentPreferences.map((preference) => [preference.consentId, preference.optIn]));
        this.bindHTML(this.dialog, consentCopy, "title", "subtitle", "richText", "selectAllText", "okButtonText");
        const copiesElement = document.querySelector(`[data-adp-ref=copies]`);
        const toAdd = consentCopy.copies.length - copiesElement.children.length;
        // Try to reuse the copies elements, remove the redundant items
        for (let i = 0; i < -toAdd; i += 1) {
            copiesElement.removeChild(copiesElement.lastElementChild);
        }
        // Try to reuse the copies elements, add the lacking items
        for (let i = 0; i < toAdd; i += 1) {
            copiesElement.appendChild((_a = copiesElement.lastElementChild) === null || _a === void 0 ? void 0 : _a.cloneNode(true));
        }
        // Reset the managed checkboxes
        this.checkboxes.length = 0;
        // Set the content/attributes of copy elements, also overwrite the exising reused elements
        for (let i = 0; i < copiesElement.children.length; i += 1) {
            const child = copiesElement.children[i];
            const copy = consentCopy.copies[i];
            this.bindHTML(child, copy, "consentName", "consentText");
            const checkbox = child.querySelector("input");
            checkbox.id = copy.consentId;
            checkbox.checked = (_b = preferences[copy.consentId]) !== null && _b !== void 0 ? _b : copy.prechecked;
            checkbox.disabled = !copy.enabled && checkbox.checked;
            this.checkboxes.push(checkbox);
        }
    }
}
exports.UserConsentDialogService = UserConsentDialogService;
